import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, Row, Col } from 'antd';
import Logo from '../../../Components/Graphics/Logo';
import { formatCompanyLogoUrl } from '../../../Api/companyApi';
import TargetAllocations from "../../../Components/TargetAllocations";
import './PortfolioRibbon.css';
import {PortfolioAvatars} from "../utils";


const PortfolioRibbon = ({ portfolio, width=500 }) => {
    const navigate = useNavigate();
    const [isModalVisible, setIsModalVisible] = React.useState(false);
    const handleNavigate = () => {
        navigate(`/public/portfolio/${portfolio.id}`);
    };

    const closeModal = () => {
        setIsModalVisible(false);
    };

    const equity = portfolio?.targets?.equity ?? 100;


    return (
        <div className={`portfolio-ribbon ${portfolio.type}`} style={{width: width}} onClick={handleNavigate}>
            <Row align="middle" wrap={false}>
                <Col flex="none">
                    <Logo height="50px" width="50px" src={formatCompanyLogoUrl(portfolio.company.cid)} alt="Company Logo" />
                </Col>
                <Col flex="auto" className="title-container">
                    <div className={'ribbon-title cursor'}>
                            {portfolio.name}
                    </div>
                </Col>
                <Col>
                    <PortfolioAvatars  userTags={portfolio?.user_tags} />
                </Col>
            </Row>
            <Modal title="Portfolio Description" visible={isModalVisible} onOk={closeModal} onCancel={closeModal}>
                <p>{portfolio.attr.summary}</p>
            </Modal>
        </div>
    );
};

export default PortfolioRibbon;
